import React from 'react';
import './Intro.css'
import './General.css'

function Intro() {
  return <>
  <div id='intro' className='IntroContainer'>
    <div className='DavidHess'>David Hess</div>
    <div className='Subtitle'>
    Software Engineer & Web Designer
    </div>
    <div className='IntroLinks'>
      <div className='IntroLink'>Experience</div>
      <div className='IntroLink'>Projects</div>
      <div className='IntroLink'>Contact</div>
    </div>
    <div className='IntroBlurb'>
      A Detroiter revolutionizing interaction with virtual environments and redefining how we consume data using web devlopment and mixed reality 
    </div>
  </div>
  </>
}

export default Intro;
